export default [
  {
    name: 'Australia',
    value: '+61',
    code: 'AU',
  },
  {
    name: 'Austria',
    value: '+43',
    code: 'AT',
  },
  {
    name: 'Brazil',
    value: '+55',
    code: 'BR',
  },
  {
    name: 'China',
    value: '+86',
    code: 'zh-CN',
  },
  {
    name: 'Denmark',
    value: '+45',
    code: 'DK',
  },
  {
    name: 'France',
    value: '+33',
    code: 'FR',
  },
  {
    name: 'Germany',
    value: '+49',
    code: 'DE',
  },
  {
    name: 'Hong Kong',
    value: '+852',
    code: 'HK',
  },
  {
    name: 'Italy',
    value: '+39',
    code: 'IT',
  },
  {
    name: 'Macao',
    value: '+853',
    code: 'MO',
  },
  {
    name: 'Singapore',
    value: '+65',
    code: 'SG',
  },
  {
    name: 'South Korea',
    value: '+82',
    code: 'KR',
  },
  {
    name: 'Spain',
    value: '+34',
    code: 'ES',
  },
  {
    name: 'Sweden',
    value: '+46',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    value: '+41',
    code: 'CH',
  },
  {
    name: 'Taiwan',
    value: '+886',
    code: 'zh-TW',
  },
  {
    name: 'United Kingdom',
    value: '+44',
    code: 'GB',
  },
];
